import React, {memo} from 'react';
import {useSelector} from 'react-redux';

import {viewSelector} from '@mapsight/ui/src/js/store/selectors';
import {VIEW_DESKTOP} from '@mapsight/ui/src/js/config/constants/app';
import {MS3_UI_MAIN_PANEL_POSITION_BELOW} from '@mapsight/ui/src/js/components/main-panel/main-panel';

import {withErrorBoundary} from '../../modules/error-boundary';
import {detailsSelector} from '../store/selectors';
import {useNavPos} from '../../hooks';

import DetailsContent from '../../stade/components/details-content';
import StadeList from '../../stade/components/list';


/**
 * @type {import("@mapsight/ui/src/js/components/contexts.js").MainPanelContainer}
 */
const MainPanelContainer = memo(function MainPanelContainer({children, panelPosition, collapsed}) {
	const navPos = useNavPos();
	const isViewDesktop = useSelector(state => viewSelector(state) === VIEW_DESKTOP);
	const details = useSelector(detailsSelector);

	if(panelPosition === MS3_UI_MAIN_PANEL_POSITION_BELOW) {
		return null; // keine Liste oder Details unterhalb der Karte anzeigen
	}

	if(isViewDesktop) {
		let content = null;
		if (navPos.list || navPos.listMorePoi) {
			content = (<StadeList />);
		} else if (/* implizit panelPosition !== "standalone" &&  */ details || navPos.home ) {
			content = (
				<DetailsContent />
			);
		}

		if(content) {
			return (
				<div className="ms3-panel-container ms3-panel-container--vertical _stade_main-panel-container">
					<div className="ms3-panel ms3-panel--docked-left">
						{content}
					</div>
				</div>
			);
		}
	}
	return children;
});

export default withErrorBoundary(MainPanelContainer);
